// What opening the draft modal for a contact should do, decided in one place because two
// surfaces answer it from two different sources and have to agree: the contact row's
// button label reads the pipeline poll, and the modal's open action reads the thread list.
//
// When they disagree the modal must NOT draft. Drafting opens a second thread and
// auto-places a second email to a live prospect, which is exactly what happened when the
// thread list came back without a draft the poll had already badged "v1".
export type OutreachDraftAction = "load" | "draft" | "cannot-load";

export const decideOutreachDraftAction = ({
  savedMessageId,
  believedDrafted,
}: {
  // The thread the modal would load, from the thread list. Null when it holds none.
  savedMessageId: string | null;
  // Whether the row that opened the modal believes a draft exists, from the poll that
  // drives its "View email" label and "v{n}" badge.
  believedDrafted: boolean;
}): OutreachDraftAction => {
  if (savedMessageId) return "load";
  return believedDrafted ? "cannot-load" : "draft";
};
